import React from "react";
import modalStyles from "../../../../css/components/overlaymodal-animations.module.css";
import styles from "../css/medical-aid-amend-modal.module.css";
import iconStyles from "../css/reversal-accepted.module.css";
import ReadOnlyInput from "../../../../components/ReadOnlyInput";
import Button from "../../../../components/Button";

export default function ReversalAcceptedModal({ onClose, onRewrite, onNCND, data = {} }) {
  const {
    authorizationNumber = "—",
    processed = "—",
    switchReference = "—",
    status = "—", // reversal transaction status (res=A → Reversed)
    claimNumber = "—", // same tx number as the reversed claim
    memberNumber = "—",
    itemStatus = "—", // per-line reversal status (A)
    financials = null, // { gross, nett, copay } of the reversed claim
    messages = [], // MK RMRs (reject/warning codes)
  } = data;

  const money = (v) => (v == null || v === "" ? "—" : `R ${Number(v).toFixed(2)}`);

  return (
    <div className={`${modalStyles.modalOverlay} ${modalStyles.show}`}>
      <div className={`${modalStyles.modalContent} ${styles.modalContent}`}>
        <div className={styles.modalHeader}>
          <div className={iconStyles.successIconWrapper} aria-hidden>
            <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="28" cy="28" r="26" className={iconStyles.successIconCircle} />
              <path d="M18 28.5L25 35.5L39 21.5" className={iconStyles.successIconCheck} />
            </svg>
          </div>
          <h2 className={styles.modalHeading}>Reversal Accepted</h2>
          <button className={modalStyles.closeButton} onClick={onClose}>&times;</button>
        </div>

        <div className={styles.content}>
          <div className={styles.formGrid}>
            {/* Reversal transaction + item status */}
            <div className={styles.formGroup}>
              <label className={styles.label}>Transaction Status</label>
              <div className={styles.compactField}>
                <ReadOnlyInput value={status} />
              </div>
            </div>
            <div className={styles.formGroup}>
              <label className={styles.label}>Item Status</label>
              <div className={styles.compactField}>
                <ReadOnlyInput value={itemStatus} />
              </div>
            </div>

            {/* Same transaction details as the reversed claim (MediKredit requirement) */}
            <div className={styles.formGroup}>
              <label className={styles.label}>Claim Number</label>
              <div className={styles.compactField}>
                <ReadOnlyInput value={claimNumber} />
              </div>
            </div>
            <div className={styles.formGroup}>
              <label className={styles.label}>Member Number</label>
              <div className={styles.compactField}>
                <ReadOnlyInput value={memberNumber} />
              </div>
            </div>

            <div className={styles.formGroup}>
              <label className={styles.label}>Switch Reference (Hnet)</label>
              <div className={styles.compactField}>
                <ReadOnlyInput value={switchReference} />
              </div>
            </div>
            <div className={styles.formGroup}>
              <label className={styles.label}>Authorization Number</label>
              <div className={styles.compactField}>
                <ReadOnlyInput value={authorizationNumber} />
              </div>
            </div>

            {/* Financials of the claim being reversed */}
            <div className={styles.formGroup}>
              <label className={styles.label}>Gross</label>
              <div className={styles.compactField}>
                <ReadOnlyInput value={money(financials?.gross)} />
              </div>
            </div>
            <div className={styles.formGroup}>
              <label className={styles.label}>Nett (scheme)</label>
              <div className={styles.compactField}>
                <ReadOnlyInput value={money(financials?.nett)} />
              </div>
            </div>
            <div className={styles.formGroup}>
              <label className={styles.label}>Co-payment</label>
              <div className={styles.compactField}>
                <ReadOnlyInput value={money(financials?.copay)} />
              </div>
            </div>
            <div className={styles.formGroup}>
              <label className={styles.label}>Processed</label>
              <div className={styles.compactField}>
                <ReadOnlyInput value={processed} />
              </div>
            </div>
          </div>

          {/* MK RMRs (reject / warning remark codes returned on the reversal) */}
          <div className={styles.formGroup} style={{ marginTop: 4 }}>
            <label className={styles.label}>MediKredit RMRs</label>
            {messages && messages.length > 0 ? (
              <ul style={{ margin: "4px 0 0", paddingLeft: 18, fontSize: "0.82rem", color: "#374151" }}>
                {messages.map((m, i) => (
                  <li key={i}>
                    {m.line ? `Line ${m.line}: ` : ""}
                    {m.desc} <span style={{ color: "#6b7280" }}>({m.code})</span>
                  </li>
                ))}
              </ul>
            ) : (
              <div style={{ fontSize: "0.82rem", color: "#6b7280", marginTop: 2 }}>None returned</div>
            )}
          </div>

          <div className={styles.buttonContainer}>
            <Button variant="primary" className={styles.smallButton} onClick={onRewrite}>Rewrite Script</Button>
            <Button variant="primary" className={styles.smallButton} onClick={onNCND || onClose}>NCND</Button>
          </div>
        </div>
      </div>
    </div>
  );
}
